import {
  ApeironLinkButton,
  AssetType,
  NextImage,
  useApeironPathMaker
} from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import {
  BANNER_SLIDE_AUTOPLAY_DURATION,
  BannerActionType
} from '@src/constants/banner'
import { useDailyCheckInContext } from '@src/contexts/reward/DailyCheckInContext'
import { Banner } from '@src/types/banner'
import * as R from 'ramda'
import * as RA from 'ramda-adjunct'
import { FC, useCallback } from 'react'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

const MainContainer = styled(Box)`
  aspect-ratio: 1040 / 210;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
`

const BannerButton = styled(ApeironLinkButton)`
  border-radius: 10px;
  height: 100%;
  overflow: hidden;
  width: 100%;
`

const BannerImage = styled(NextImage)`
  height: 100%;
  pointer-events: none;
  width: 100%;
`

const StyledSwiper = styled(Swiper)`
  height: 100%;
  width: 100%;

  & .swiper-pagination {
    bottom: 5px;
    display: flex;
    gap: 20px;
    justify-content: center;
    left: 50%;
    position: absolute;
    transform: translate(-50%, 0px);
    z-index: 1;
  }
  & .swiper-pagination-bullet {
    aspect-ratio: 1;
    background-color: #00000099;
    border-radius: 50%;
    width: 10px;
  }
  & .swiper-pagination-bullet-active {
    background-color: white;
  }
`

const CheckInBanners: FC<Props> = (props: Props) => {
  const { className, onClick } = props

  const { banner } = useDailyCheckInContext()

  const { makePath } = useApeironPathMaker()

  const handleOnBannerClick = useCallback(
    (banner: Banner) => {
      if (R.isNotNil(onClick)) {
        onClick(banner)
      }
    },
    [onClick]
  )

  return (
    <>
      {!R.isEmpty(banner) && (
        <MainContainer className={className}>
          <StyledSwiper
            autoplay={{
              delay: BANNER_SLIDE_AUTOPLAY_DURATION,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop
            modules={[Autoplay, Pagination]}
            pagination={{ clickable: true }}
          >
            {RA.mapIndexed((banner: Banner, index: number) => {
              const supportLink = banner.actionType === BannerActionType.Link

              const onClick = !supportLink
                ? () => handleOnBannerClick(banner)
                : undefined

              const url = supportLink ? banner.actionValue : undefined

              return (
                <SwiperSlide key={index}>
                  <BannerButton onClick={onClick} url={url} target='_blank'>
                    <BannerImage
                      src={makePath(AssetType.Image, banner.bannerImage)}
                    />
                  </BannerButton>
                </SwiperSlide>
              )
            }, banner ?? [])}
          </StyledSwiper>
        </MainContainer>
      )}
    </>
  )
}

type Props = {
  className?: string
  onClick?: (banner: Banner) => void
}

export default CheckInBanners
